import { c as _c } from "react/compiler-runtime";
export const VaultDistributionPartialNotice = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <p data-testid="vault-distribution-partial-notice" className="text-secondary-foreground text-sm">Some holders could not be loaded, so this page may be incomplete.</p>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};